export const isChanged = (differences, value) =>
  differences?.find((d) => d.modifiedField === value);
